module.exports = "https://www.gc-pro.gnp.com.mx/ddb06d8a8f003a961933f6016cde30a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/reparacion/02.png
// module id = 1057
// module chunks = 0 1